import { TOGGLE_MENU, SET_REFERRAL } from '@/store/mutation-types'

const state = {
  isMenuOpen: false,
  referral: {}
}

const getters = {
  hasReferral () {
    return !!state.referral.name
  },
  link (state, getters, rootState) {
    return ({ name, params, query }) => ({
      name,
      query,
      params: { ...params, locale: rootState.i18n.locale }
    })
  }
}

const mutations = {
  [TOGGLE_MENU] (state) {
    state.isMenuOpen = !state.isMenuOpen
  },
  [SET_REFERRAL] (state, referral) {
    state.referral = referral
  }
}

export default {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/nav.js